import {useMemo} from 'react';

import {selectUser, useAppSelector} from '@/app/store';
import logError from '@/utils/errors/logError';

import {useGetCardThemesQuery} from './api';
import {CardThemeModel} from './entities';
import {getCardThemesMapper} from './mapper';
import {useTrackers} from './trackers';

export const useCardsThemeRepository = () => {
  const userData = useAppSelector(selectUser);

  const {
    data: getCardThemesData,
    isFetching: isFetchingCardThemes,
    error,
  } = useGetCardThemesQuery();

  const {
    trackApiErrorCardThemeListRetrieval,
    trackApiSuccessCardThemeListRetrieval,
  } = useTrackers();

  const cardThemes = useMemo(() => {
    if (error || !getCardThemesData) {
      if (error) {
        trackApiErrorCardThemeListRetrieval(userData?.id, error);
        logError(error, {
          customTitle: 'Card Theme - Error fetching card themes',
          fileName: 'useRepository Cards theme',
          functionName: 'cardThemes',
        });
      }
      return {themes: []} as CardThemeModel;
    }

    if (getCardThemesData)
      trackApiSuccessCardThemeListRetrieval(
        getCardThemesData.themes,
        userData?.id,
      );
    return getCardThemesMapper(getCardThemesData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCardThemesData]);

  return {
    cardThemes,
    isFetchingCardThemes,
  };
};
